import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import Icon from '../../icon/Icon';
import ChatApp from '../../chat/app/ChatApp';
import ChatAppSound from '../../chat/app/ChatAppSound';

import styles from './styles';
import { getCurrentAppRoute, getAppIsBlacklisted } from './selectors';
import API from '../../../api/api';
import * as chatSelectors from '../../chat/app/ChatApp/selectors';

export class App extends PureComponent {
  renderRoute() {
    const { route, blackListed } = this.props;
    switch (route) {
      case 'kusty':
        return blackListed ? null : <Icon />;
      case 'app':
        return <ChatApp />;
      default:
        return null;
    }
  }

  render() {
    return (
      <div style={styles} className="kustomer" data-kt="root-route">
        <ChatAppSound />
        {this.renderRoute()}
      </div>
    );
  }
}

App.propTypes = {
  route: PropTypes.string,
  blackListed: PropTypes.bool,
};

App.defaultProps = {
  route: 'kusty',
  blackListed: false,
};

const mapStateToProps = state => {
  const activity = chatSelectors.getLastActivity(state);
  const shouldMaintainActiveChats = API.shouldMaintainActiveChats(activity);
  const appBlackListed = getAppIsBlacklisted(state);

  return {
    route: getCurrentAppRoute(state),
    blackListed: appBlackListed && !shouldMaintainActiveChats,
  };
};

export default connect(mapStateToProps)(App);
